import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { jobConstants, jobModels } from '..';

export const useJobResults = (
  props: { enabled?: boolean; id?: number; onSuccess?: (data: jobModels.IJobResult[]) => void } = {}
) =>
  useQuery<jobModels.IJobResult[]>({
    queryKey: [jobConstants.queryKeys.JOB_RESULT, props?.id],
    queryFn: async () => {
      const res = await $api.get('/v1/job/results');

      return res.data.data;
    },
    onSuccess: data => {
      if (props?.onSuccess) {
        props?.onSuccess(data);
      }
    },
    enabled: props?.enabled,
    refetchInterval: 1500
  });
